module.exports = __webpack_public_path__ + "img/136.32188e21.jpg";